module.exports = __webpack_public_path__ + "img/map_google_en.99737f28.jpg";